var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.7998C6.26863 4.7998 6 5.06843 6 5.39981V18.5998C6 18.9312 6.26863 19.1998 6.6 19.1998C6.93137 19.1998 7.2 18.9312 7.2 18.5998V5.3998C7.2 5.06843 6.93137 4.7998 6.6 4.7998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.28 12.9598C17.6776 12.9598 18 12.6375 18 12.2398C18 11.8422 17.6776 11.5198 17.28 11.5198H10.9076L12.979 9.63881C13.2657 9.36319 13.2746 8.9074 12.999 8.62077C12.7234 8.33413 12.2676 8.32519 11.981 8.60081L8.62096 11.7208C8.47979 11.8566 8.4 12.044 8.4 12.2398C8.4 12.4357 8.47979 12.6231 8.62096 12.7588L11.981 15.8788C12.2676 16.1544 12.7234 16.1455 12.999 15.8588C13.2746 15.5722 13.2657 15.1164 12.979 14.8408L10.9076 12.9598H17.28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.fca0bba0a16290fb1d25438eaf8d467d.svg";
export { ForwardRef as ReactComponent };